import _ from "lodash";

/**
 * Persisted-state migrations for redux-persist. Bump `PERSIST_VERSION` and add a step
 * whenever a persisted slice drops or renames fields — the level-1 reconciler otherwise
 * keeps the old slice object (including removed keys) forever.
 */
export const PERSIST_VERSION = 1;

export const persistMigrations: Record<number, (state: any) => any> = {
    // 1 (Sept 2026): the browser no longer holds a TDMS token. Strip the removed
    // agent-token fields from `auth` and drop the deleted `sharedToken` slice.
    1: (state) => {
        if (!state) return state;
        const rest = _.omit(state, ["sharedToken"]);
        if (rest.auth && typeof rest.auth === "object") {
            rest.auth = _.omit(rest.auth, ["auth", "tokenInfoAuth", "isAgentTokenInvalid"]);
        }
        return rest;
    },
};
